import React from 'react';
import PropTypes from 'prop-types';
import Facet from './Facet';
import styles from './FacetList.module.less';
import clsx from 'clsx';

const FacetList = ({ facetsArray = [], onClick, topLevel = false }) => {
  const tagsList = facetsArray.map(function(facet) {
    return (
      <Facet
        key={facet.urlName}
        displayName={facet.display}
        internalName={facet.internalName}
        urlName={facet.urlName}
        href={facet.href}
        disabled={facet.disabled}
        selected={facet.selected}
        nestedTags={facet.children}
        onClick={onClick}
        hasChildren={facet.hasChildren}
      />
    );
  });
  return (
    <ul className={clsx(styles.facets, topLevel && styles.topLevel)}>
      {tagsList}
    </ul>
  );
};

export default FacetList;

FacetList.propTypes = {
  facetsArray: PropTypes.array,
  onClick: PropTypes.func,
  topLevel: PropTypes.bool,
};
